import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as SearchIcon } from './search.svg';

export const Search = IconHOC(SearchIcon);
